import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import withName from "../../hoc/withName";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faPencilAlt, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import ButtonPrime from "../PrimeComponents/ButtonPrime";

const DatosFact = ({farmInfo,countries, values, setFieldValue,header, noEditable, errors, setValidate,validate,
    setEditable, ownEditBtns ,handleSubmit, setOriginalValues, formikRef, originalValues, newDatosFact, setNewDatosFact, newDatosFactList, setNewDatosFactList}) => {
    const {t, i18n} = useTranslation();
    const [billingData, setBillingData] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(() => {
        if(farmInfo && !billingData){
            setFieldValue("datos_fact",farmInfo.datos_fact);
            setBillingData([
                {"datos_fact_id":0,
                    "vat_id":"",
                    "nombre":t("billing.policyPage.newBillingData"),
                    "n_cliente_id":farmInfo?.n_cliente_id,
                    "direccion":"",
                    "ciudad":""}].concat(farmInfo?.datos_fact_list));
            setIsLoaded(true);
        }
    },[farmInfo,billingData]);
    useEffect(() => {
        if(newDatosFactList){
            setBillingData([
                {"datos_fact_id":0,
                    "vat_id":"",
                    "nombre":t("billing.policyPage.newBillingData"),
                    "n_cliente_id":farmInfo?.n_cliente_id,
                    "direccion":"",
                    "ciudad":""}].concat(newDatosFactList));
            setNewDatosFactList(null);
        }
    },[newDatosFactList]);

    useEffect(() => {
        if(newDatosFact){
            if(newDatosFact?.n_cliente_id !== billingData?.[0]?.n_cliente_id){
                const newData = {...billingData?.[0], n_cliente_id:newDatosFact?.n_cliente_id};
                setBillingData([newData,newDatosFact]);
            }else{
                setBillingData(billingData.concat(newDatosFact));
            }
            setFieldValue("datos_fact",newDatosFact);
            setNewDatosFact(null);
        }
    },[newDatosFact]);

    useEffect(() => {
        if(countries){
            countries.forEach(c => {
                c.nombre = t(`countries.${c.tipo_pais_id}`);
            });
        }
    },[countries,t]);

    useEffect(() => {
        if(!validate){
            formikRef?.current?.validateForm();
        }
    },[validate]);
    if(isLoaded){
        return (
            <div className="card">
                <div className="card-body">
                    {
                        header?
                            <>
                                {
                                    ownEditBtns?
                                        <div className='row'>
                                            <div className='col col-sm-2 col-md-3 col-lg-3' />
                                            <div className='col col-sm-10 col-md-8 col-lg-6 text-center'>
                                                <h5 className="card-title"><span>{t("billing.billingData")}</span></h5>
                                            </div>
                                            <div className='col col-sm-3 col-md-3 col-lg-3 d-flex justify-content-end align-items-right align-items-center'>

                                                {
                                                    noEditable?
                                                        <FontAwesomeIcon
                                                            className='btnEdit pointer'
                                                            icon={faPencilAlt}
                                                            style={{ color: "grey", fontSize:"1.65rem", marginRight:"15px", cursor:"pointer" }}
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                setOriginalValues({...formikRef?.current?.values});
                                                                setEditable(true);
                                                            }}
                                                        >{t("forms.edit")}</FontAwesomeIcon>
                                                        :
                                                        <>
                                                            <ButtonPrime t={t} template="formSave" onClick={(e) => {
                                                                setFieldValue("origin","datos_fact");
                                                                handleSubmit(e);
                                                            }} tooltip={t("forms.save")} tooltipOptions={{ className:"tooltip-prime", position:"bottom"}}
                                                            />
                                                            <ButtonPrime t={t} template="formCancel"
                                                                tooltip={t("forms.cancel")} tooltipOptions={{ className:"tooltip-prime", position:"bottom"}}
                                                                onClick={() => {
                                                                    setEditable(false);
                                                                    formikRef.current && formikRef.current.setFieldValue("servicio_id",originalValues?.servicio_id);
                                                                    formikRef.current && formikRef.current.setFieldValue("tipo_cobro",originalValues?.tipo_cobro);
                                                                    formikRef.current && formikRef.current.setFieldValue("mes_facturacion",originalValues?.mes_facturacion);
                                                                    formikRef.current && formikRef.current.setFieldValue("timeout_estado_billing",originalValues?.timeout_estado_billing);
                                                                    formikRef.current && formikRef.current.setFieldValue("n_cliente_id",originalValues?.n_cliente_id);
                                                                    formikRef.current && formikRef.current.setFieldValue("mes_facturacion",originalValues?.mes_facturacion);
                                                                    formikRef.current && formikRef.current.setFieldValue("integrador_id",originalValues?.integrador_id);
                                                                    formikRef.current && formikRef.current.setFieldValue("datos_fact",originalValues?.datos_fact);
                                                                }}
                                                            />
                                                        </>
                                                }
                                            </div>
                                        </div>
                                        :<div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                                            <h5 className="card-title"><span>{t("billing.billingData")}</span></h5>
                                        </div>
                                }
                                <div className='linea-titulo' />

                            </>
                            :null
                    }
                    <div className="row linea-formulario">
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            <label className="boldie">{t("billing.policyPage.farmName")}</label>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            <label>{farmInfo?.nombre}</label>
                        </div>
                    </div>
                    {
                        noEditable?
                            null
                            :<div className="row linea-formulario">
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("billing.billingData")}</label>
                                </div>
                                <div className="col-xl-6 col-lg-12 col-sm-12">
                                    <Dropdown
                                        value={values?.datos_fact?.datos_fact_id}
                                        onChange={(e) => {
                                            const itemData = billingData?.find(m => m.datos_fact_id === e.value);
                                            setFieldValue("datos_fact.vat_id",itemData?.vat_id);
                                            setFieldValue("datos_fact.tipo_pais_id",itemData?.tipo_pais_id);
                                            setFieldValue("datos_fact.pais",countries?.find(c => c?.tipo_pais_id === itemData?.tipo_pais_id)?.descripcion);
                                            setFieldValue("datos_fact.direccion",itemData?.direccion);
                                            setFieldValue("datos_fact.ciudad",itemData?.ciudad);
                                            setFieldValue("datos_fact.nombre",itemData?.nombre);
                                            setFieldValue("datos_fact.n_cliente_id",itemData?.n_cliente_id);
                                            if(e.value ===0){
                                                setFieldValue("datos_fact.nombre","");
                                            }
                                            setFieldValue("datos_fact.datos_fact_id",e?.value);
                                            if(e?.value !== 0){
                                                setValidate(true);
                                            }
                                        }}
                                        options={billingData} optionLabel="nombre" optionValue="datos_fact_id"
                                        className="flex lgInputCstm w-100 p-0-ddpr" placeholder={t("billing.policyPage.sellectData")}
                                        inputId="datos_fact_id" name="datos_fact_id"
                                    />
                                </div>
                            </div>
                    }
                    <div className="row linea-formulario">
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            <label className="boldie">{t("general.name")}</label>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            {
                                noEditable?
                                    <label>{billingData?.find(m => m.datos_fact_id === values?.datos_fact?.datos_fact_id)?.nombre}</label>
                                    :
                                    <>
                                        <InputText className="flex lgInputCstmDialog w-100 " value={values?.datos_fact?.nombre} name="datos_fact.nombre" onChange={(e) => {
                                            const index = billingData?.findIndex(m => m.datos_fact_id === values?.datos_fact?.datos_fact_id);
                                            if(index >0){
                                                billingData[index].nombre = e.target.value;
                                            }
                                            setFieldValue("datos_fact.nombre",e.target.value);
                                        }}
                                        />
                                        {errors?.datos_fact_nombre? <small className="p-error text-danger">{t("validation.required")}</small>:null}
                                    </>
                            }
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            <label className="boldie">{t("billing.policyPage.vat")}</label>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            {
                                noEditable?
                                    <label>{values?.datos_fact?.vat_id}</label>
                                    :
                                    <>
                                        <InputText className="flex lgInputCstmDialog w-100 " value={values?.datos_fact?.vat_id} name="datos_fact.vat_id" onChange={(e) => setFieldValue("datos_fact.vat_id",e.target.value)} />
                                        {errors?.datos_fact_vat_id? <small className="p-error text-danger">{t("validation.required")}</small>:null}
                                    </>
                            }
                        </div>
                    </div>

                    <div className="row linea-formulario">
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            <label className="boldie">{t("personal.address")}</label>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            {
                                noEditable?
                                    <label>{values?.datos_fact?.direccion}</label>
                                    :
                                    <>
                                        <InputText className="flex lgInputCstmDialog w-100 " value={values?.datos_fact?.direccion} name="datos_fact.direccion" onChange={(e) => setFieldValue("datos_fact.direccion",e.target.value)} />
                                        {errors?.datos_fact_direccion? <small className="p-error text-danger">{t("validation.required")}</small>:null}
                                    </>
                            }
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            <label className="boldie">{t("personal.city")}</label>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            {
                                noEditable?
                                    <label>{values?.datos_fact?.ciudad}</label>
                                    :
                                    <>
                                        <InputText className="flex lgInputCstmDialog w-100 " value={values?.datos_fact?.ciudad} name="datos_fact.ciudad" onChange={(e) => setFieldValue("datos_fact.ciudad",e.target.value)} />
                                        {errors?.datos_fact_ciudad? <small className="p-error text-danger">{t("validation.required")}</small>:null}
                                    </>
                            }
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            <label className="boldie">{t("billing.policyPage.country")}</label>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-sm-12">
                            {
                                noEditable?
                                    <label >{t(`countries.${values?.datos_fact?.tipo_pais_id}`)}</label>
                                    :
                                    <>
                                        <Dropdown
                                            value={values?.datos_fact?.tipo_pais_id}
                                            onChange={(e) => {
                                                setFieldValue("datos_fact.pais",countries?.find(c => c?.tipo_pais_id === e?.value)?.descripcion);
                                                setFieldValue("datos_fact.tipo_pais_id",e?.value);
                                            }}
                                            options={countries} optionLabel="nombre" optionValue="tipo_pais_id"
                                            className="flex lgInputCstm w-100 p-0-ddpr" placeholder={t("billing.policyPage.country")}
                                            inputId="datos_fact_country" name="datos_fact_country"
                                        />
                                        {errors?.datos_fact_tipo_pais_id? <small className="p-error text-danger">{t("validation.required")}</small>:null}
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    else{
        return null;
    }
};

export default withName(DatosFact, "DatosFact");
